// ============================================
// App Module - Display Functions (ES6)
// ============================================

import { getCurrentUser } from './state.js';
import { loadChatList } from '../chat/list.js';
import { loadUserData, showSplashAuth, stopSplashAnimation, closeEmailLoginModal } from '../auth/index.js';

// ============================================
// 스플래시 화면 관리
// ============================================

export function hideSplashScreen() {
  const splash = document.getElementById('splashScreen');
  if (splash) {
    // 스플래시 애니메이션 정리
    stopSplashAnimation();

    splash.classList.add('fade-out');
    // 애니메이션 후 완전히 제거 (visibility로 유지하여 애니메이션 보존)
    setTimeout(() => {
      splash.style.visibility = 'hidden';
      splash.style.pointerEvents = 'none';
    }, 500);
  }
}

export function showSplashAsLogin() {
  const splash = document.getElementById('splashScreen');
  if (splash) {
    splash.classList.remove('fade-out');
    splash.style.visibility = 'visible';
    splash.style.pointerEvents = 'auto';

    // 로그인 버튼 표시 및 애니메이션 시작
    showSplashAuth();
  }
}

// ============================================
// 앱 표시
// ============================================

export async function showApp(isLoggedIn = false) {
  console.log('showApp called, isLoggedIn:', isLoggedIn);
  // 로그인 상태가 아니면 스플래시를 로그인 화면으로 표시
  if (!isLoggedIn) {
    console.log('Not logged in, showing splash as login');
    // 앱 컨테이너는 숨김 유지
    document.getElementById('appContainer').classList.remove('active');
    showSplashAsLogin();
    return;
  }

  // 로그인 상태일 때
  document.getElementById('appContainer').classList.add('active');

  // 이메일 로그인 모달이 열려 있으면 닫기
  closeEmailLoginModal();

  // Update user info displays
  const user = getCurrentUser();
  const email = user?.email || '로그인 필요';
  if (document.getElementById('userEmail')) {
    document.getElementById('userEmail').textContent = email;
  }
  if (document.getElementById('myPageEmail')) {
    document.getElementById('myPageEmail').textContent = email;
  }

  // 홈 탭 먼저 활성화 (UI 준비)
  if (typeof window.switchTab === 'function') {
    window.switchTab('home');
  }

  // 병렬로 데이터 로드
  const loadPromises = [];

  // 홈 콘텐츠는 항상 로드 (필수)
  if (typeof window.loadHomeContent === 'function') {
    loadPromises.push(
      window.loadHomeContent().catch(e => console.error('loadHomeContent error:', e))
    );
  }

  // 로그인 상태일 때 추가 데이터 로드
  if (isLoggedIn && user) {
    loadPromises.push(
      loadUserData().catch(e => console.error('loadUserData error:', e))
    );
    loadPromises.push(
      loadChatList().catch(e => console.error('loadChatList error:', e))
    );
  }

  // 모든 데이터 로드 완료 대기
  await Promise.allSettled(loadPromises);

  // 스플래시 숨기기
  hideSplashScreen();

  // 무한 스크롤 설정
  if (typeof window.setupInfiniteScroll === 'function') {
    window.setupInfiniteScroll();
  }
}

// ============================================
// window 함수 노출 (기존 코드 호환성)
// ============================================

window.hideSplashScreen = hideSplashScreen;
window.showSplashAsLogin = showSplashAsLogin;
window.showApp = showApp;
